import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinshirdi() {



    const cardData = {





keyword: "Swift Dzire On Rent in Shirdi",

headingDescription: "Sai Shirdi Cab provides Swift Dzire On Rent in Shirdi for devotees, families, tourists, business travelers, local residents, and customers looking for a comfortable and economical car with a professional driver. Swift Dzire is suitable for local travel in Shirdi, Sai Baba Temple visits, railway station transfers, hotel pickups and drops, airport transfers, nearby sightseeing, and outstation journeys. Customers can hire a Dzire for one-way travel, round trips, full-day use, local sightseeing, or customized outstation trips according to their requirements. The car is a practical choice for small families and groups who need comfortable seating, useful luggage space, and convenient door-to-door transportation. Sai Shirdi Cab provides experienced drivers, clean and well-maintained vehicles, flexible pickup timings, and convenient booking options. Customers can also use a Swift Dzire for nearby destinations around Shirdi such as Kopargaon, Rahata, Manmad, Yeola, Sangamner, Sinnar, and Nashik.",

topPlaces: [
  {
    title: "Nashik",
    description: "Nashik is a popular outstation destination from Shirdi for pilgrimage, business travel, family trips, and sightseeing. Customers can hire a Swift Dzire from Shirdi for comfortable one-way or round-trip travel to Nashik. The journey can also be extended to Trimbakeshwar and other nearby destinations according to the travel plan."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is a popular outstation destination from Shirdi for historical sightseeing, family travel, business visits, and pilgrimage tours. A Swift Dzire is suitable for small families and groups looking for comfortable private transportation from Shirdi to the city and nearby attractions."
  },
  {
    title: "Ahmednagar",
    description: "Ahmednagar is a convenient outstation destination from Shirdi for business, family, and personal travel. Customers can rent a Swift Dzire with a driver for direct or round-trip journeys. The car is a practical choice for passengers looking for economical and comfortable transportation from Shirdi."
  },
  {
    title: "Pune",
    description: "Pune is an important outstation destination from Shirdi for business, education, family visits, and tourism. Customers can hire a Swift Dzire for one-way or return travel from Shirdi to Pune. The vehicle is suitable for small families and travelers carrying normal luggage."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major long-distance destination from Shirdi for business, family visits, airport travel, and tourism. Customers can book a Swift Dzire with a professional driver for direct transportation from Shirdi to Mumbai. One-way and round-trip options can be arranged according to the itinerary."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a popular pilgrimage destination that can be visited from Shirdi by private cab. Customers can rent a Swift Dzire for a convenient round trip from Shirdi, making it suitable for devotees and families planning a religious journey with flexible travel timings."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a prominent Jyotirlinga destination that can be covered from Shirdi in a private Swift Dzire. Customers can plan a dedicated trip or combine Trimbakeshwar with Nashik and other nearby pilgrimage destinations. The car is suitable for small families and devotees."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is an important pilgrimage destination for travelers starting their journey from Shirdi. A Swift Dzire can be hired for a comfortable outstation trip with a flexible itinerary. Customers can choose a round-trip journey for temple visits and return travel to Shirdi."
  },
  {
    title: "Saptashrungi",
    description: "Saptashrungi Devi Temple at Vani is a popular pilgrimage destination that can be included in an outstation journey from Shirdi. Customers can hire a Swift Dzire for a family or devotional trip with convenient pickup and return arrangements. The route can also be combined with Nashik sightseeing."
  },
  {
    title: "Ajanta Ellora Caves",
    description: "Ajanta and Ellora Caves are popular heritage destinations that can be visited from Shirdi through a customized outstation cab trip. Customers can rent a Swift Dzire for sightseeing with a planned route covering the caves and nearby attractions. The service is suitable for families and small groups."
  }
],







"services": [
{
"name": "Swift Dzire On Rent in Shirdi",
"description": "Swift Dzire On Rent in Shirdi provides a convenient car rental option for travelers looking for a comfortable and practical vehicle. The car can be arranged for local travel, outstation journeys, airport transfers, railway station pickups, sightseeing, and customized travel requirements."
},
{
"name": "Swift Dzire Rental in Shirdi",
"description": "Swift Dzire Rental in Shirdi offers a suitable transportation solution for individuals, families, and business travelers. Rental arrangements can be planned according to travel duration, passenger count, luggage requirements, pickup location, destination, and one-way or round-trip needs."
},
{
"name": "Swift Dzire Car Rental Shirdi",
"description": "Swift Dzire Car Rental Shirdi provides a reliable vehicle option for local and intercity transportation. Customers can arrange the car according to their preferred travel schedule, passenger requirements, luggage capacity, trip duration, and selected pickup and drop locations."
},
{
"name": "Swift Dzire On Hire Shirdi",
"description": "Swift Dzire On Hire Shirdi is suitable for travelers who need a comfortable car for personal trips, sightseeing, pilgrimage travel, and outstation journeys. The vehicle can be hired according to the required duration, route, passenger capacity, and travel itinerary."
},
{
"name": "Swift Dzire Cab On Rent Shirdi",
"description": "Swift Dzire Cab On Rent Shirdi provides a practical private cab option for travelers requiring convenient transportation. The cab can be arranged for local sightseeing, hotel transfers, temple visits, airport travel, railway station transfers, and longer intercity journeys."
},
{
"name": "Swift Dzire Taxi On Rent Shirdi",
"description": "Swift Dzire Taxi On Rent Shirdi offers comfortable transportation for passengers traveling within Shirdi or toward nearby and outstation destinations. Taxi arrangements can be planned according to travel timing, passenger count, luggage, pickup point, destination, and preferred trip type."
},
{
"name": "Swift Dzire With Driver Shirdi",
"description": "Swift Dzire With Driver Shirdi provides a convenient chauffeur-driven travel option for customers who prefer assisted transportation. The vehicle can be arranged for local trips, pilgrimage visits, sightseeing, airport transfers, railway station pickups, and outstation travel."
},
{
"name": "Swift Dzire Car Hire Shirdi",
"description": "Swift Dzire Car Hire Shirdi allows travelers to arrange a compact and comfortable vehicle for different travel requirements. Customers can select suitable hire arrangements based on trip duration, passenger count, luggage, route, pickup location, and one-way or return transportation."
},
{
"name": "Swift Dzire Outstation Rental Shirdi",
"description": "Swift Dzire Outstation Rental Shirdi is suitable for passengers planning private journeys from Shirdi to nearby cities and other destinations. The rental can be organized according to the travel route, duration, passenger requirements, luggage, vehicle needs, and selected trip type."
},
{
"name": "Swift Dzire One Way Rental Shirdi",
"description": "Swift Dzire One Way Rental Shirdi provides direct transportation for travelers who need a vehicle for a single journey without requiring a return trip. The car can be arranged from the preferred pickup point in Shirdi to the selected destination."
},
{
"name": "Swift Dzire Round Trip Rental Shirdi",
"description": "Swift Dzire Round Trip Rental Shirdi is a convenient option for travelers planning to visit another destination and return to Shirdi. The rental schedule can be organized according to travel dates, journey duration, passenger count, waiting requirements, and preferred return itinerary."
},
{
"name": "Swift Dzire Airport Cab Shirdi",
"description": "Swift Dzire Airport Cab Shirdi provides convenient airport transportation for passengers requiring a private vehicle for pickup or drop-off. The cab can be coordinated with flight schedules and arranged according to passenger count, luggage requirements, airport location, and destination."
},
{
"name": "Swift Dzire Railway Station Cab Shirdi",
"description": "Swift Dzire Railway Station Cab Shirdi offers private transportation for passengers arriving at or departing from railway stations around Shirdi. Pickup and drop arrangements can be scheduled according to train timings, luggage, passenger count, preferred vehicle, and final destination."
},
{
"name": "Swift Dzire Local Rental Shirdi",
"description": "Swift Dzire Local Rental Shirdi provides a practical car option for local travel, temple visits, hotel transfers, sightseeing, shopping, and nearby destinations. Customers can plan the rental according to the required travel duration, number of passengers, pickup location, and itinerary."
},
{
"name": "Swift Dzire Tourist Cab Shirdi",
"description": "Swift Dzire Tourist Cab Shirdi is suitable for travelers exploring Shirdi and nearby tourist or pilgrimage destinations. The cab can be arranged for sightseeing trips, temple visits, family outings, local tours, and customized itineraries with convenient pickup and drop facilities."
},
{
"name": "Swift Dzire Booking Shirdi",
"description": "Swift Dzire Booking Shirdi allows customers to reserve a suitable vehicle in advance for their planned journey. Booking arrangements can include travel dates, pickup timing, passenger count, luggage requirements, destination, rental duration, and preferred one-way or round-trip service."
},
{
"name": "Swift Dzire Cab Booking Shirdi",
"description": "Swift Dzire Cab Booking Shirdi provides an easy way to arrange private transportation for local and outstation journeys. Travelers can request a cab according to their preferred pickup point, travel schedule, passenger capacity, luggage needs, destination, and trip requirements."
},
{
"name": "Affordable Swift Dzire Rental Shirdi",
"description": "Affordable Swift Dzire Rental Shirdi offers a budget-conscious transportation option for travelers seeking a practical vehicle without compromising everyday travel convenience. Rental plans can be selected according to the journey type, duration, passenger requirements, route, and vehicle usage."
},
{
"name": "Best Swift Dzire Rental Shirdi",
"description": "Best Swift Dzire Rental Shirdi provides a comfortable car rental choice for travelers planning local, pilgrimage, sightseeing, airport, railway station, and outstation journeys. The service can be customized according to travel schedules, passenger requirements, luggage, and destination preferences."
},
{
"name": "Swift Dzire Taxi Service Shirdi",
"description": "Swift Dzire Taxi Service Shirdi provides private transportation for passengers traveling around Shirdi and toward other destinations. The taxi can be arranged for local transfers, temple visits, sightseeing, airport or railway station travel, one-way journeys, and round-trip transportation."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Swift Dzire and other private cab options for local travel, outstation journeys, airport transfers, railway station pickups, sightseeing, pilgrimage trips, and car rental requirements in Shirdi. Suitable vehicles can be arranged according to passenger count, luggage, travel schedule, and destination."
}
],
"tableData": [
["Swift Dzire On Rent in Shirdi", "Swift Dzire Rental in Shirdi"],
["Swift Dzire Car Rental Shirdi", "Swift Dzire On Hire Shirdi"],
["Swift Dzire Cab On Rent Shirdi", "Swift Dzire Taxi On Rent Shirdi"],
["Swift Dzire With Driver Shirdi", "Swift Dzire Car Hire Shirdi"],
["Swift Dzire Outstation Rental Shirdi", "Swift Dzire One Way Rental Shirdi"],
["Swift Dzire Round Trip Rental Shirdi", "Swift Dzire Airport Cab Shirdi"],
["Swift Dzire Railway Station Cab Shirdi", "Swift Dzire Local Rental Shirdi"],
["Swift Dzire Tourist Cab Shirdi", "Swift Dzire Booking Shirdi"],
["Swift Dzire Cab Booking Shirdi", "Affordable Swift Dzire Rental Shirdi"],
["Best Swift Dzire Rental Shirdi", "Swift Dzire Taxi Service Shirdi"],
["Sai Shirdi Cabs", "Swift Dzire On Rent in Shirdi"]
]
,







    whychoose: [
        { 
            WhyChooseheading: "Swift Dzire on Rent in Shirdi for Comfortable Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides Swift Dzire on rent in Shirdi for devotees, families, tourists, business travellers, and individuals looking for a practical private car. The vehicle can be considered for Sai Baba Darshan, local sightseeing, airport and railway station transfers, hotel transportation, and outstation journeys from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Comfortable Sedan for Shirdi Travel", 
            WhyChoosedescription: "Swift Dzire is a practical sedan option for passengers who prefer comfortable travel for short and long-distance journeys. It is suitable for individuals, couples, and small families travelling with a manageable amount of luggage." 
        }, 
        { 
            WhyChooseheading: "Ideal for Sai Baba Darshan Trips", 
            WhyChoosedescription: "Devotees can rent a Swift Dzire for transportation between their hotel, Sai Baba Temple, railway station, and other nearby pilgrimage locations. A private sedan provides convenient travel without depending on shared transportation." 
        }, 
        { 
            WhyChooseheading: "Swift Dzire for Local Sightseeing", 
            WhyChoosedescription: "Book a Swift Dzire for Shirdi local sightseeing and nearby attractions. Travellers can plan multiple stops according to their preferred itinerary, available time, and sightseeing requirements." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Rental Options", 
            WhyChoosedescription: "Choose a one-way Swift Dzire rental when you need direct transportation to another destination, or arrange a round-trip service when you want transportation for both onward and return journeys from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Suitable for Airport & Railway Transfers", 
            WhyChoosedescription: "Swift Dzire can be booked for airport and railway station transportation from Shirdi. Passengers can share their flight or train schedule and pickup details while planning the required transfer." 
        }, 
        { 
            WhyChooseheading: "Swift Dzire for Outstation Travel", 
            WhyChoosedescription: "Travellers can rent a Swift Dzire for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Ahmednagar, and other cities according to their travel itinerary." 
        }, 
        { 
            WhyChooseheading: "Book Swift Dzire on Rent in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage details, rental duration, one-way or round-trip requirement, and preferred travel schedule with Sai Shirdi Cabs to arrange a suitable Swift Dzire rental." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I rent a Swift Dzire in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides Swift Dzire rental services in Shirdi for local travel, Sai Baba Darshan, sightseeing, transfers, and outstation journeys." 
    }, 
    { 
        question: "Is Swift Dzire suitable for Sai Baba Darshan?", 
        answer: "Yes, Swift Dzire is a practical sedan option for devotees travelling between hotels, Sai Baba Temple, railway stations, and other pilgrimage locations in Shirdi." 
    }, 
    { 
        question: "Can I book Swift Dzire for Shirdi sightseeing?", 
        answer: "Yes, Swift Dzire can be arranged for Shirdi sightseeing and nearby destinations according to your preferred places and travel schedule." 
    }, 
    { 
        question: "Can I book Swift Dzire for one-way travel from Shirdi?", 
        answer: "Yes, one-way Swift Dzire travel can be arranged for passengers who require direct transportation from Shirdi to another destination without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I rent Swift Dzire for a round trip?", 
        answer: "Yes, round-trip Swift Dzire rental can be arranged for travellers who need transportation to their destination and back to Shirdi." 
    }, 
    { 
        question: "Can Swift Dzire be used for airport transfers?", 
        answer: "Yes, Swift Dzire can be booked for airport pickup and drop services according to your flight schedule and transportation requirements." 
    }, 
    { 
        question: "Can I book Swift Dzire from Shirdi Railway Station?", 
        answer: "Yes, Swift Dzire can be arranged for pickup from or drop to the railway station according to your train schedule and travel requirements." 
    }, 
    { 
        question: "Is Swift Dzire available for outstation travel from Shirdi?", 
        answer: "Yes, Swift Dzire can be booked for outstation journeys from Shirdi to various cities and tourist destinations depending on your itinerary." 
    }, 
    { 
        question: "How many passengers can travel in a Swift Dzire?", 
        answer: "Swift Dzire is generally suitable for small groups, couples, and families. The practical passenger and luggage capacity should be confirmed according to the specific travel requirement." 
    }, 
    { 
        question: "How can I book Swift Dzire on Rent in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, passenger count, luggage details, rental duration, and one-way or return requirement with Sai Shirdi Cabs to proceed with the Swift Dzire booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Prakash More", 
        feedback: "We rented a Swift Dzire in Shirdi for our family Darshan and local sightseeing. The sedan was a practical choice for our small group and made travelling between the planned locations convenient.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Neha Patil", 
        feedback: "I booked a Swift Dzire for an outstation trip from Shirdi. The car was a comfortable option for our journey and provided enough space for our small family and luggage.", 
        rating: 5 
    } 
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/swift-dzire-on-rent-in-shirdi.webp",
  "description":
    "Book a Swift Dzire On Rent in Shirdi with Sai Shirdi Cabs for comfortable and reliable local and outstation travel. Get a well-maintained Swift Dzire with professional driver service for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station transfers, one-way trips, round trips, and outstation journeys. Enjoy easy booking assistance, convenient pickup and drop locations, and affordable rental service in Shirdi.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/swift-dzire-on-rent-in-shirdi"
  }
};




    return (
        <div>

<Helmet>
  <title>Swift Dzire On Rent in Shirdi | Swift Dzire Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book Swift Dzire on rent in Shirdi with Sai Shirdi Cabs. Get a comfortable Swift Dzire with driver for Sai Baba Darshan, sightseeing, airport and railway station transfers, one-way, round trips and outstation travel."
  />

  <meta
    name="keywords"
    content="Swift Dzire On Rent in Shirdi, Swift Dzire rental in Shirdi, Swift Dzire car rental Shirdi, Swift Dzire on hire Shirdi, Swift Dzire cab on rent Shirdi, Swift Dzire taxi on rent Shirdi, Swift Dzire with driver Shirdi, Swift Dzire car hire Shirdi, Swift Dzire outstation rental Shirdi, Swift Dzire one way rental Shirdi, Swift Dzire round trip rental Shirdi, Swift Dzire airport cab Shirdi, Swift Dzire railway station cab Shirdi, Swift Dzire local rental Shirdi, Swift Dzire tourist cab Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinshirdi;